import React from 'react'
import { useTranslation } from 'react-i18next'

import RevealContactInfo from '../../RevealContactInfo'
import RevealFetchErrorDetails from '../../fetchErrorDetails/RevealFetchErrorDetails'

import DismissableMessageClearingFetchStatus from './DismissableMessageClearingFetchStatus'

import {
  DISPLAYED_ERROR_MESSAGES_UNKNOWN_SERVER_ERROR,
} from '../../../constants'


export default ({
  formName,
  errorDetails,
}) => {
  const { t: translate } = useTranslation('common')
  return (
  <DismissableMessageClearingFetchStatus
    error
    formName={formName}
    content={
      <div>
        <p>{translate(DISPLAYED_ERROR_MESSAGES_UNKNOWN_SERVER_ERROR)}</p>
        <div>
          <RevealContactInfo
            asPopup
          />
          <RevealFetchErrorDetails
            errorDetails={errorDetails}
            asPopup
          />
        </div>
      </div>
    }
  />
)}
